module.exports = __webpack_public_path__ + "img/bullets.aab8cac5.svg";